/**
 * Created by mugambi on 26/03/17.
 */
export const REMAINING_ITEMS = 'accounts/REMAINING_ITEMS'
export const SOLD_UNITS = 'accounts/SOLD_UNITS'
export const BOUGHT_UNITS = 'accounts/BOUGHT_UNITS'



// WEBPACK FOOTER //
// ./client/store/modules/accounts/mutation-types.js